<script setup>
defineProps({
  image: {
    type: Object,
    default: () => {},
  },
  title: {
    type: String,
    default: () => '',
  },
  article: {
    type: String,
    default: () => '',
  },
  url: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <CTagDetect v-if="url" :to="url" class="car-extra bg-white black text-center">
    <div class="car-extra__media">
      <NuxtImg
        v-if="image?.src"
        :src="image?.src"
        :alt="image?.alt"
        :height="image?.height"
        :width="image?.width"
        class="car-extra__image"
        loading="lazy"
      />
    </div>
    <div class="car-extra__info">
      <p v-if="title" class="mb-0 car-extra__title h5" v-html="title"></p>
      <p v-if="article" class="mb-0 car-extra__article body-3-regular">
        <span class="car-extra__article-title">{{ $t('car.article') }}</span>
        {{ article }}
      </p>
    </div>
  </CTagDetect>
  <div v-else class="car-extra bg-white black text-center">
    <div class="car-extra__media">
      <NuxtImg
        v-if="image?.src"
        :src="image?.src"
        :alt="image?.alt"
        :height="image?.height"
        :width="image?.width"
        class="car-extra__image"
        loading="lazy"
      />
    </div>
    <div class="car-extra__info">
      <p v-if="title" class="mb-0 car-extra__title h5" v-html="title"></p>
      <p v-if="article" class="mb-0 car-extra__article body-3-regular">
        <span class="car-extra__article-title">{{ $t('car.article') }}</span>
        {{ article }}
      </p>
    </div>
  </div>
</template>
<style scoped lang="scss">
@use 'sass:math';
.car-extra {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  padding: 16px;
  @include media-breakpoint-up(md) {
    gap: 16px;
    padding: 24px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(border-radius, 8);
    @include responsive-spacing(gap, 16);
    @include responsive-spacing(padding, 24);
  }
  &__media {
    border-radius: 4px;
    aspect-ratio: 280/232;
    overflow: hidden;
    @include media-breakpoint-up(sm) {
      aspect-ratio: 194/184;
    }
    @include media-breakpoint-up(md) {
      aspect-ratio: 1/1;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 4);
    }
  }
  &__image {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
  &__info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-bottom: 24px;
    @include media-breakpoint-up(sm) {
      padding-bottom: 0;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 16);
    }
  }
  &__title {
    margin: 0 auto;
    width: 72%;
    @include media-breakpoint-up(sm) {
      width: 100%;
    }
  }
  &__article {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 12px;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 12);
    }
    &-title {
      color: $on-surface-variant-2;
    }
  }
}
</style>
